/**
 * Default unpaid break for a shift — single source of truth for the backend
 * payout-disclosure snapshot (15-H) and the portal's sign-timesheet form.
 *
 * Operator rule (2026-10-27, revises 15-H's `>= 5`): a shift of 5 hours or less
 * defaults to no break; a shift longer than 5 hours defaults to 30 minutes. It is
 * only a default — the break on the buyer-signed timesheet stays authoritative.
 */
export const DEFAULT_BREAK_THRESHOLD_HOURS = 5;
export const DEFAULT_BREAK_MINUTES = 30;
export function defaultBreakMinutes(shiftHours) {
    return shiftHours > DEFAULT_BREAK_THRESHOLD_HOURS ? DEFAULT_BREAK_MINUTES : 0;
}
//# sourceMappingURL=break-default.js.map